// Daily Challenges and Achievement System Data
// This file contains data for daily challenges, streaks, and achievements

export const dailyChallengesData = {
  title: {
    traditional: '每日挑戰',
    simplified: '每日挑战',
    english: 'Daily Challenge'
  },
  streakCard: {
    streak: 7,
    label: {
      traditional: '天連擊',
      simplified: '天连击',
      english: 'Day Streak'
    },
    message: {
      traditional: '繼續保持學習動力!',
      simplified: '继续保持学习动力!',
      english: 'Keep up the learning momentum!'
    }
  },
  userStats: [
    {
      id: 'level',
      value: 12,
      label: {
        traditional: '等級',
        simplified: '等级',
        english: 'Level'
      },
      color: 'text-white'
    },
    {
      id: 'xp',
      value: 2340,
      label: {
        traditional: '經驗值',
        simplified: '经验值',
        english: 'Experience'
      },
      color: 'text-green-400'
    },
    {
      id: 'accuracy',
      value: '85%',
      label: {
        traditional: '準確度',
        simplified: '准确度',
        english: 'Accuracy'
      },
      color: 'text-purple-400'
    }
  ],
  todayChallenges: {
    title: {
      traditional: '今日挑戰',
      simplified: '今日挑战',
      english: 'Today\'s Challenges'
    },
    challenges: [
      {
        id: 'pronunciation_challenge',
        title: {
          traditional: '發音挑戰',
          simplified: '发音挑战',
          english: 'Pronunciation Challenge'
        },
        description: {
          traditional: '正確發音 10 個困難單字',
          simplified: '正确发音 10 个困难单词',
          english: 'Correctly pronounce 10 difficult words'
        },
        reward: 50,
        isCompleted: true,
        statusIcon: '✓',
        statusColor: 'text-green-400'
      },
      {
        id: 'conversation_fluency',
        title: {
          traditional: '對話流暢度',
          simplified: '对话流畅度',
          english: 'Conversation Fluency'
        },
        description: {
          traditional: '完成 3 分鐘流暢對話',
          simplified: '完成 3 分钟流畅对话',
          english: 'Complete a 3-minute fluent conversation'
        },
        reward: 100,
        isCompleted: false,
        statusIcon: '🎯',
        statusColor: 'text-blue-400'
      },
      {
        id: 'intonation_practice',
        title: {
          traditional: '語調練習',
          simplified: '语调练习',
          english: 'Intonation Practice'
        },
        description: {
          traditional: '練習 5 種不同情緒語調',
          simplified: '练习 5 种不同情绪语调',
          english: 'Practice 5 different emotional intonations'
        },
        reward: 75,
        isCompleted: false,
        statusIcon: '🎯',
        statusColor: 'text-blue-400'
      },
      {
        id: 'vocabulary_challenge',
        title: {
          traditional: '詞彙挑戰',
          simplified: '词汇挑战',
          english: 'Vocabulary Challenge'
        },
        description: {
          traditional: '學習並使用 15 個新詞彙',
          simplified: '学习并使用 15 个新词汇',
          english: 'Learn and use 15 new vocabulary words'
        },
        reward: 80,
        isCompleted: false,
        statusIcon: '🎯',
        statusColor: 'text-blue-400'
      }
    ]
  },
  bottomActions: [
    {
      id: 'leaderboard',
      title: {
        traditional: '排行榜',
        simplified: '排行榜',
        english: 'Leaderboard'
      },
      icon: '🏆',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      id: 'achievements',
      title: {
        traditional: '成就',
        simplified: '成就',
        english: 'Achievements'
      },
      icon: '👤',
      gradient: 'from-green-500 to-blue-500'
    }
  ]
};

export const achievementsData = {
  title: {
    traditional: '成就系統',
    simplified: '成就系统',
    english: 'Achievement System'
  },
  unlockProgress: {
    title: {
      traditional: '解鎖進度',
      simplified: '解锁进度',
      english: 'Unlock Progress'
    },
    unlocked: 3,
    total: 6,
    progress: 50
  },
  categories: [
    {
      id: 'all',
      title: {
        traditional: '全部',
        simplified: '全部',
        english: 'All'
      },
      isActive: true
    },
    {
      id: 'unlocked',
      title: {
        traditional: '已解鎖',
        simplified: '已解锁',
        english: 'Unlocked'
      },
      isActive: false
    },
    {
      id: 'in_progress',
      title: {
        traditional: '進行中',
        simplified: '进行中',
        english: 'In Progress'
      },
      isActive: false
    }
  ],
  achievements: [
    {
      id: 'beginner',
      title: {
        traditional: '初學者',
        simplified: '初学者',
        english: 'Beginner'
      },
      description: {
        traditional: '完成第一堂課',
        simplified: '完成第一堂课',
        english: 'Complete the first lesson'
      },
      icon: '🎯',
      isUnlocked: true,
      status: {
        traditional: '已完成',
        simplified: '已完成',
        english: 'Completed'
      },
      statusIcon: '✓',
      statusColor: 'text-green-400',
      gradient: 'from-orange-400 to-orange-600'
    },
    {
      id: 'streak_master',
      title: {
        traditional: '連擊達人',
        simplified: '连击达人',
        english: 'Streak Master'
      },
      description: {
        traditional: '連續學習7天',
        simplified: '连续学习7天',
        english: 'Study continuously for 7 days'
      },
      icon: '🔥',
      isUnlocked: true,
      status: {
        traditional: '已完成',
        simplified: '已完成',
        english: 'Completed'
      },
      statusIcon: '✓',
      statusColor: 'text-green-400',
      gradient: 'from-orange-400 to-orange-600'
    },
    {
      id: 'pronunciation_expert',
      title: {
        traditional: '發音專家',
        simplified: '发音专家',
        english: 'Pronunciation Expert'
      },
      description: {
        traditional: '發音準確度達95%',
        simplified: '发音准确度达95%',
        english: 'Pronunciation accuracy reaches 95%'
      },
      icon: '🎤',
      isUnlocked: true,
      status: {
        traditional: '已完成',
        simplified: '已完成',
        english: 'Completed'
      },
      statusIcon: '✓',
      statusColor: 'text-green-400',
      gradient: 'from-orange-400 to-orange-600'
    },
    {
      id: 'social_butterfly',
      title: {
        traditional: '社交蝴蝶',
        simplified: '社交蝴蝶',
        english: 'Social Butterfly'
      },
      description: {
        traditional: '參與 10 次群組對話',
        simplified: '参与 10 次群组对话',
        english: 'Participate in 10 group conversations'
      },
      icon: '🔒',
      isUnlocked: false,
      status: null,
      statusIcon: null,
      statusColor: null,
      gradient: 'from-blue-800 to-purple-800'
    },
    {
      id: 'language_master',
      title: {
        traditional: '語言大師',
        simplified: '语言大师',
        english: 'Language Master'
      },
      description: {
        traditional: '完成所有課程',
        simplified: '完成所有课程',
        english: 'Complete all courses'
      },
      icon: '🔒',
      isUnlocked: false,
      status: null,
      statusIcon: null,
      statusColor: null,
      gradient: 'from-blue-800 to-purple-800'
    },
    {
      id: 'ar_explorer',
      title: {
        traditional: 'AR 探索者',
        simplified: 'AR 探索者',
        english: 'AR Explorer'
      },
      description: {
        traditional: '使用AR 模式20次',
        simplified: '使用AR 模式20次',
        english: 'Use AR mode 20 times'
      },
      icon: '🔒',
      isUnlocked: false,
      status: null,
      statusIcon: null,
      statusColor: null,
      gradient: 'from-blue-800 to-purple-800'
    }
  ],
  shareButton: {
    title: {
      traditional: '分享成就',
      simplified: '分享成就',
      english: 'Share Achievement'
    },
    icon: '📤'
  }
};

// Helper functions
export const getDailyChallengesData = () => dailyChallengesData;

export const getAchievementsData = () => achievementsData;

export const getChallengeById = (challengeId) => {
  return dailyChallengesData.todayChallenges.challenges.find(
    challenge => challenge.id === challengeId
  );
};

export const getAchievementById = (achievementId) => {
  return achievementsData.achievements.find(
    achievement => achievement.id === achievementId
  );
};

export const updateChallengeCompletion = (challengeId, isCompleted) => {
  const challenge = getChallengeById(challengeId);
  if (challenge) {
    challenge.isCompleted = isCompleted;
    challenge.statusIcon = isCompleted ? '✓' : '🎯';
    challenge.statusColor = isCompleted ? 'text-green-400' : 'text-blue-400';
  }
};

export const updateAchievementUnlock = (achievementId, isUnlocked) => {
  const achievement = getAchievementById(achievementId);
  if (achievement) {
    achievement.isUnlocked = isUnlocked;
    if (isUnlocked) {
      achievement.status = {
        traditional: '已完成',
        simplified: '已完成',
        english: 'Completed'
      };
      achievement.statusIcon = '✓';
      achievement.statusColor = 'text-green-400';
      achievement.gradient = 'from-orange-400 to-orange-600';
    }
  }
};

export const calculateUnlockProgress = () => {
  const unlockedCount = achievementsData.achievements.filter(a => a.isUnlocked).length;
  const totalCount = achievementsData.achievements.length;
  return {
    unlocked: unlockedCount,
    total: totalCount,
    progress: Math.round((unlockedCount / totalCount) * 100)
  };
};
